module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/doctors/noimage_s150x150-ef4653e0f97c09944fea0631b0994a80.jpg";